import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import {
  PublicOrganisationTrial,
  StartTrialDto,
} from "@classview/shared-types";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

const startTrial = async ({
  organisationId,
  trial,
}: {
  organisationId: string;
  trial: StartTrialDto;
}): Promise<PublicOrganisationTrial> => {
  const response = await axiosClient.post(
    `organisation-trials/${organisationId}`,
    trial,
  );
  return response.data;
};

function useStartTrial(
  mutationOptions?: UseMutationOptions<
    PublicOrganisationTrial,
    HttpError,
    { organisationId: string; trial: StartTrialDto }
  >,
) {
  return useMutation({
    mutationFn: startTrial,
    ...mutationOptions,
  });
}

export { useStartTrial };
